export default {
  'holidays public administer': 'Administer customer holiday schedules',
}
